import { render, staticRenderFns } from "./ListUsers.vue?vue&type=template&id=fbb755c4&scoped=true&"
import script from "./ListUsers.vue?vue&type=script&lang=js&"
export * from "./ListUsers.vue?vue&type=script&lang=js&"
import style0 from "./ListUsers.vue?vue&type=style&index=0&id=fbb755c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb755c4",
  null
  
)

export default component.exports